import { Box, Typography } from "@mui/material";

const StatisticsHeader = (): JSX.Element => {
  return (
    <Box padding="0" marginBottom="1em">
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Typography variant="h3">Statistics</Typography>
      </Box>
    </Box>
  );
};

export default StatisticsHeader;
